(function () {
  var config = window.nsLimeChatContext || {};
  if (!config.enabled) return;

  var defaultTemplates = {
    product: 'Hi Nidharshana Sarees, I need help with this order: {product_title} - {product_url}',
    collection: 'Hi, I was at your "{collection_title}" page and wanted help in placing order of a particular saree. {collection_url}',
    home: 'Hi Nidharshana Sarees, I was browsing your homepage and need help placing an order. {current_url}',
    defaultMessage: 'Hi Nidharshana Sarees, I was browsing your website and need help. Page: {page_title} - {current_url}'
  };

  config.templates = config.templates || {};
  config.templates.product = config.templates.product || defaultTemplates.product;
  config.templates.collection = config.templates.collection || defaultTemplates.collection;
  config.templates.home = config.templates.home || defaultTemplates.home;
  config.templates.defaultMessage = config.templates.defaultMessage || defaultTemplates.defaultMessage;

  var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  if ((isMobile && !config.mobileEnabled) || (!isMobile && !config.desktopEnabled)) return;

  var state = {
    currentVariantId: config.product && config.product.variantId ? String(config.product.variantId) : '',
    fallbackTimer: null,
    observer: null,
    enhanceTimer: null
  };

  function cleanPhone(value) {
    return String(value || '').replace(/[^\d]/g, '');
  }

  function absoluteUrl(pathOrUrl) {
    if (!pathOrUrl) return window.location.href;
    try {
      return new URL(pathOrUrl, window.location.origin).toString();
    } catch (error) {
      return window.location.href;
    }
  }

  function productUrl() {
    var base = absoluteUrl(config.product && config.product.url);
    if (!state.currentVariantId) return base;

    try {
      var url = new URL(base);
      url.searchParams.set('variant', state.currentVariantId);
      return url.toString();
    } catch (error) {
      return base.indexOf('?') === -1 ? base + '?variant=' + state.currentVariantId : base + '&variant=' + state.currentVariantId;
    }
  }

  function pageContext() {
    if (config.template === 'product' && config.product && config.product.title) {
      return {
        type: 'product',
        template: config.templates.product,
        url: productUrl(),
        product_title: config.product.title,
        product_url: productUrl(),
        variant_id: state.currentVariantId
      };
    }

    if (config.template === 'collection' && config.collection && config.collection.title) {
      return {
        type: 'collection',
        template: config.templates.collection,
        url: absoluteUrl(config.collection.url),
        collection_title: config.collection.title,
        collection_url: absoluteUrl(config.collection.url)
      };
    }

    if (config.template === 'index') {
      return {
        type: 'home',
        template: config.templates.home,
        url: window.location.href
      };
    }

    return {
      type: 'default',
      template: config.templates.defaultMessage,
      url: window.location.href
    };
  }

  function replaceTokens(template, context) {
    var pageTitle = config.pageTitle || document.title || '';
    var url = context.url || window.location.href;

    return String(template || '')
      .replace(/\{product_title\}/g, context.product_title || '')
      .replace(/\{product_url\}/g, context.product_url || url)
      .replace(/\{variant_id\}/g, context.variant_id || '')
      .replace(/\{collection_title\}/g, context.collection_title || '')
      .replace(/\{collection_url\}/g, context.collection_url || url)
      .replace(/\{page_title\}/g, pageTitle)
      .replace(/\{current_url\}/g, window.location.href)
      .replace(/\{url\}/g, url)
      .replace(/\s+/g, ' ')
      .trim();
  }

  function buildWhatsAppHref() {
    var phone = cleanPhone(config.phone);
    if (!phone) return '';

    var context = pageContext();
    var message = replaceTokens(context.template, context);
    return 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
  }

  function getLimeChatLinks() {
    return Array.prototype.slice.call(document.querySelectorAll('.WhatsAppButton__root a'));
  }

  function updateFallbackWhatsApp() {
    var fallback = document.querySelector('[data-ns-limechat-contact-button="whatsapp"]');
    if (fallback) fallback.href = buildWhatsAppHref();
  }

  function scheduleEnhanceLinks(delay) {
    window.clearTimeout(state.enhanceTimer);
    state.enhanceTimer = window.setTimeout(enhanceLinks, delay || 0);
  }

  function enhanceLinks() {
    var href = buildWhatsAppHref();
    if (!href) return false;

    var context = pageContext();
    var links = getLimeChatLinks();
    links.forEach(function (link) {
      if (link.getAttribute('href') !== href) {
        link.href = href;
      }
      link.dataset.nsLimechatContext = context.type;
      link.setAttribute('aria-label', 'Chat with Nidharshana Sarees on WhatsApp');
    });
    updateFallbackWhatsApp();

    if (links.length) {
      removeFallbackWhatsApp();
      return true;
    }
    return false;
  }

  function injectStyles() {
    if (document.getElementById('ns-limechat-context-style')) return;

    var desktopBottom = Number(config.social && config.social.desktopBottom) || 96;
    var mobileBottom = Number(config.social && config.social.mobileBottom) || 92;
    var side = Number(config.social && config.social.sideSpacing) || 18;
    var style = document.createElement('style');
    style.id = 'ns-limechat-context-style';
    style.textContent = [
      '.WhatsAppButton__root{z-index:7900!important;}',
      '.WhatsAppButton__root a{display:flex!important;align-items:center;justify-content:center;min-width:42px;min-height:42px;}',
      '.WhatsAppButton__root img{display:block!important;opacity:1!important;visibility:visible!important;}',
      '.ns-limechat-contact-rail{position:fixed;right:' + side + 'px;bottom:' + desktopBottom + 'px;z-index:7900;display:flex;flex-direction:column;gap:10px;pointer-events:none;}',
      '.ns-limechat-contact-rail__button{width:44px;height:44px;border-radius:999px;background:#6D2077;color:#fff;display:flex;align-items:center;justify-content:center;box-shadow:0 14px 30px rgba(109,32,119,.25);border:1px solid rgba(255,255,255,.45);pointer-events:auto;transition:transform .18s ease,box-shadow .18s ease,background .18s ease;}',
      '.ns-limechat-contact-rail__button:hover{transform:translateY(-2px);background:#8B3A8B;box-shadow:0 18px 36px rgba(109,32,119,.32);}',
      '.ns-limechat-contact-rail__button svg{width:20px;height:20px;display:block;}',
      '.ns-limechat-contact-rail__button--whatsapp{background:#128C7E;}',
      '.ns-limechat-contact-rail__button--facebook{background:#1877F2;}',
      '.ns-limechat-contact-rail__button--instagram{background:linear-gradient(135deg,#6D2077,#D62976,#FCAF45);}',
      'html[data-ns-night-mode="dark"] .ns-limechat-contact-rail__button{border-color:rgba(255,255,255,.24);box-shadow:0 14px 34px rgba(0,0,0,.42);}',
      '@media (max-width:767px){.ns-limechat-contact-rail{right:' + Math.max(12, side - 2) + 'px;bottom:' + mobileBottom + 'px;gap:8px;}.ns-limechat-contact-rail__button{width:42px;height:42px;}}',
      '@media (prefers-reduced-motion:reduce){.ns-limechat-contact-rail__button{transition:none;}.ns-limechat-contact-rail__button:hover{transform:none;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function icon(name) {
    if (name === 'instagram') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7.8 2h8.4A5.8 5.8 0 0 1 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8A5.8 5.8 0 0 1 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2Zm0 2A3.8 3.8 0 0 0 4 7.8v8.4A3.8 3.8 0 0 0 7.8 20h8.4a3.8 3.8 0 0 0 3.8-3.8V7.8A3.8 3.8 0 0 0 16.2 4H7.8Zm4.2 3.3A4.7 4.7 0 1 1 12 16.7a4.7 4.7 0 0 1 0-9.4Zm0 2A2.7 2.7 0 1 0 12 14.7a2.7 2.7 0 0 0 0-5.4Zm5-2.1a1.1 1.1 0 1 1-1.1 1.1A1.1 1.1 0 0 1 17 7.2Z"/></svg>';
    }
    if (name === 'facebook') {
      return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M22 12.06C22 6.49 17.52 2 12 2S2 6.49 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.84c0-2.52 1.5-3.91 3.78-3.91 1.1 0 2.24.2 2.24.2v2.47H15.2c-1.24 0-1.63.78-1.63 1.56v1.9h2.78l-.44 2.91h-2.34V22C18.34 21.24 22 17.08 22 12.06Z"/></svg>';
    }
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12.04 2a9.86 9.86 0 0 0-8.38 15.04L2.5 21.5l4.57-1.2A9.9 9.9 0 1 0 12.04 2Zm0 1.8a8.09 8.09 0 0 1 6.86 12.38 8.09 8.09 0 0 1-10.92 2.3l-.33-.2-2.71.71.72-2.64-.22-.34A8.07 8.07 0 0 1 12.04 3.8Zm4.61 11.43c-.25.7-1.24 1.31-1.73 1.36-.47.04-1.05.06-1.7-.11-.39-.1-.9-.29-1.55-.57-2.72-1.17-4.5-3.9-4.64-4.08-.14-.18-1.1-1.46-1.1-2.79 0-1.33.7-1.98.95-2.25.25-.27.55-.34.73-.34h.53c.17 0 .4-.06.62.47.25.6.84 2.04.91 2.19.07.15.12.33.02.51-.1.18-.15.29-.3.45-.15.17-.32.37-.46.5-.15.15-.31.31-.13.61.18.3.78 1.28 1.68 2.07 1.16 1.03 2.13 1.35 2.43 1.5.3.15.48.13.66-.08.18-.22.76-.88.96-1.18.2-.3.4-.25.68-.15.28.1 1.77.83 2.07.98.3.15.5.23.58.36.07.12.07.72-.18 1.42Z"/></svg>';
  }

  function ensureRail() {
    var rail = document.querySelector('[data-ns-limechat-contact-rail]');
    if (rail) return rail;

    injectStyles();
    rail = document.createElement('div');
    rail.className = 'ns-limechat-contact-rail';
    rail.setAttribute('data-ns-limechat-contact-rail', '');
    document.body.appendChild(rail);
    return rail;
  }

  function addRailButton(options) {
    if (!options.href || document.querySelector('[data-ns-limechat-contact-button="' + options.key + '"]')) return;

    var rail = ensureRail();
    var link = document.createElement('a');
    link.className = 'ns-limechat-contact-rail__button ns-limechat-contact-rail__button--' + options.key;
    link.href = options.href;
    link.target = '_blank';
    link.rel = 'noopener';
    link.setAttribute('aria-label', options.label);
    link.setAttribute('data-ns-limechat-contact-button', options.key);
    link.innerHTML = icon(options.icon || options.key);
    rail.appendChild(link);
  }

  function renderSocialButtons() {
    var social = config.social || {};
    if (!social.enabled) return;

    if (social.instagramEnabled && social.instagramUrl) {
      addRailButton({
        key: 'instagram',
        icon: 'instagram',
        href: social.instagramUrl,
        label: 'Open Nidharshana Sarees on Instagram'
      });
    }

    if (social.facebookEnabled && social.facebookUrl) {
      addRailButton({
        key: 'facebook',
        icon: 'facebook',
        href: social.facebookUrl,
        label: 'Open Nidharshana Sarees on Facebook'
      });
    }
  }

  function renderFallbackWhatsApp() {
    if (!config.fallback || !config.fallback.enabled || getLimeChatLinks().length) return;
    addRailButton({
      key: 'whatsapp',
      icon: 'whatsapp',
      href: buildWhatsAppHref(),
      label: 'Chat with Nidharshana Sarees on WhatsApp'
    });
  }

  function removeFallbackWhatsApp() {
    var fallback = document.querySelector('[data-ns-limechat-contact-button="whatsapp"]');
    if (fallback) fallback.remove();
  }

  function scheduleFallback() {
    if (!config.fallback || !config.fallback.enabled) return;
    window.clearTimeout(state.fallbackTimer);
    state.fallbackTimer = window.setTimeout(renderFallbackWhatsApp, (Number(config.fallback.delaySeconds) || 12) * 1000);
  }

  function bindVariantUpdates() {
    document.addEventListener('on:variant:change', function (event) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        state.currentVariantId = String(event.detail.variant.id);
        scheduleEnhanceLinks(60);
      }
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches('form[action*="/cart/add"] [name="id"], .js-product-form [name="id"]')) return;
      state.currentVariantId = event.target.value || state.currentVariantId;
      scheduleEnhanceLinks(60);
    });
  }

  function isLimeChatLaunchTarget(target) {
    if (!target || !target.closest) return false;
    if (target.closest('.WhatsAppButton__root a')) return true;
    if (target.closest('#whatsapp-cta-button')) return true;
    var popup = target.closest('#whatsapp-first-time-popup');
    return popup && !target.closest('#whatsapp-close-popup');
  }

  function bindLaunchGuards() {
    ['pointerdown', 'touchstart', 'click'].forEach(function (eventName) {
      document.addEventListener(eventName, function (event) {
        if (!isLimeChatLaunchTarget(event.target)) return;
        enhanceLinks();
      }, true);
    });
  }

  function observeLimeChat() {
    enhanceLinks();

    if (!('MutationObserver' in window)) {
      window.setInterval(enhanceLinks, 1500);
      return;
    }

    state.observer = new MutationObserver(function (mutations) {
      var shouldEnhance = mutations.some(function (mutation) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'href' &&
          mutation.target &&
          mutation.target.matches &&
          mutation.target.matches('.WhatsAppButton__root a')
        ) {
          return mutation.target.getAttribute('href') !== buildWhatsAppHref();
        }

        return Array.prototype.slice.call(mutation.addedNodes).some(function (node) {
          return node.nodeType === 1 && (
            node.matches && node.matches('.WhatsAppButton__root, .WhatsAppButton__root a') ||
            node.querySelector && node.querySelector('.WhatsAppButton__root a')
          );
        });
      });

      if (shouldEnhance) scheduleEnhanceLinks(20);
    });

    state.observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['href'],
      childList: true,
      subtree: true
    });
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  ready(function () {
    injectStyles();
    bindVariantUpdates();
    bindLaunchGuards();
    observeLimeChat();
    renderSocialButtons();
    scheduleFallback();
  });
})();
